"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSupplierIncompleteData = void 0;
const hasSupplierIncompleteData = (supplier) => {
    const invalidSections = [];
    if (!supplier.contact_info?.reservations?.email)
        invalidSections.push("Reservations Email");
    if (!supplier.contact_info?.accounts?.email)
        invalidSections.push("Accounts Email");
    if (!supplier.contact_info?.general?.email)
        invalidSections.push("General Contact Email");
    if (!supplier.contact_info?.general?.phone)
        invalidSections.push("General Contact Phone");
    if (!supplier.contact_info?.emergency_contact?.phone)
        invalidSections.push("Emergency Contact Phone");
    if (supplier?.offerings?.golf?.enabled) {
        if (!supplier?.offerings?.golf?.min_notice_required)
            invalidSections.push("Golf Min Notice Required");
        if (supplier?.offerings?.golf?.offerings?.caddies?.input_vat === null)
            invalidSections.push("Golf Caddies Input VAT");
        if (supplier?.offerings?.golf?.offerings?.caddies?.vat === null)
            invalidSections.push("Golf Caddies Output VAT");
        if (supplier?.offerings?.golf?.offerings?.caddies?.withholding_tax === null)
            invalidSections.push("Golf Caddies Withholding Tax");
        if (supplier?.offerings?.golf?.offerings?.carts?.input_vat === null)
            invalidSections.push("Golf Carts Input VAT");
        if (supplier?.offerings?.golf?.offerings?.carts?.vat === null)
            invalidSections.push("Golf Carts Output VAT");
        if (supplier?.offerings?.golf?.offerings?.carts?.withholding_tax === null)
            invalidSections.push("Golf Carts Withholding Tax");
        if (supplier?.offerings?.golf?.offerings?.green_fees?.input_vat === null)
            invalidSections.push("Golf Green Fees Input VAT");
        if (supplier?.offerings?.golf?.offerings?.green_fees?.vat === null)
            invalidSections.push("Golf Green Fees Output VAT");
        if (supplier?.offerings?.golf?.offerings?.green_fees?.withholding_tax === null)
            invalidSections.push("Golf Green Fees Withholding Tax");
    }
    if (supplier?.offerings?.hotels?.enabled) {
        if (!supplier?.offerings?.hotels?.min_notice_required)
            invalidSections.push("Hotel Min Notice Required");
        if (supplier?.offerings?.hotels?.offerings?.hotels?.input_vat === null)
            invalidSections.push("Hotel Input VAT");
        if (supplier?.offerings?.hotels?.offerings?.hotels?.vat === null)
            invalidSections.push("Hotel Output VAT");
        if (supplier?.offerings?.hotels?.offerings?.hotels?.withholding_tax === null)
            invalidSections.push("Hotel Withholding Tax");
    }
    if (supplier?.offerings?.transfers?.enabled) {
        if (!supplier?.offerings?.transfers?.min_notice_required)
            invalidSections.push("Transfer Min Notice Required");
        if (supplier?.offerings?.transfers?.offerings?.transfers?.input_vat === null)
            invalidSections.push("Transfer Input VAT");
        if (supplier?.offerings?.transfers?.offerings?.transfers?.vat === null)
            invalidSections.push("Transfer Output VAT");
        if (supplier?.offerings?.transfers?.offerings?.transfers?.withholding_tax ===
            null)
            invalidSections.push("Transfer Withholding Tax");
    }
    if (supplier?.offerings?.excursions?.enabled) {
        if (!supplier?.offerings?.excursions?.min_notice_required)
            invalidSections.push("Excursion Min Notice Required");
        if (supplier?.offerings?.excursions?.offerings?.excursions?.input_vat === null)
            invalidSections.push("Excursion Input VAT");
        if (supplier?.offerings?.excursions?.offerings?.excursions?.vat === null)
            invalidSections.push("Excursion Output VAT");
        if (supplier?.offerings?.excursions?.offerings?.excursions
            ?.withholding_tax === null)
            invalidSections.push("Excursion Withholding Tax");
    }
    if (supplier?.offerings?.custom?.enabled) {
        if (!supplier?.offerings?.custom?.min_notice_required)
            invalidSections.push("Custom Min Notice Required");
        if (supplier?.offerings?.custom?.offerings?.custom?.input_vat === null)
            invalidSections.push("Custom Input VAT");
        if (supplier?.offerings?.custom?.offerings?.custom?.vat === null)
            invalidSections.push("Custom Output VAT");
        if (supplier?.offerings?.custom?.offerings?.custom?.withholding_tax === null)
            invalidSections.push("Custom Withholding Tax");
    }
    if (!supplier?.billing_settings?.payment_source)
        invalidSections.push("Payment Source");
    if (!supplier?.billing_settings?.type)
        invalidSections.push("Billing Type");
    if (supplier?.billing_settings?.type === "PAYG" &&
        !supplier?.billing_settings?.payment_terms)
        invalidSections.push("PAYG Payment Terms");
    if (supplier?.billing_settings?.type === "WEEKLY_BILLING" &&
        !supplier?.billing_settings?.day_of_week)
        invalidSections.push("Weekly Billing Day of Week");
    if (supplier?.billing_settings?.type === "MONTHLY_BILLING" &&
        !supplier?.billing_settings?.day_of_month)
        invalidSections.push("Monthly Billing Day of Month");
    if (supplier?.billing_settings?.type === "CREDIT_LIMIT" &&
        !supplier?.billing_settings?.credit_limit)
        invalidSections.push("Credit Limit");
    return invalidSections;
};
exports.hasSupplierIncompleteData = hasSupplierIncompleteData;
